import React from "react";
import { PanelBarGLPure, ChatBoxGLPure } from "../../pures";
import { Grid } from '@material-ui/core'
import { Tooltip } from "@progress/kendo-react-tooltip";
import { newProfileIcon } from "../../../assets/logos/icons";
import "./validate-freelance.css";

const ValidateFreelanceChatView = (props) => {

    let {
        t,
        membersChat,
        usersChat,
        conversation,
        createMessage,
        markChatAsRead,
        handleInputChangeChat
    } = props

    return (
        <div className="validateFreelanceDocumentsView-panel-chat">
            <PanelBarGLPure
                expandedPanel={false}
                titlePanel={t("validateFreelanceView.panel.chat")}
                className='validateFreelanceDocumentsView'
            >
                <div className=''>
                    <Grid className="validateFreelanceView-headerUsersChat">
                        <span className="validateFreelanceView-titleGrid">
                            {t("validateFreelanceView.title.chat")}
                        </span>
                        <div className="validateFreelanceView-containersAvatars">
                            {membersChat.map((item, index) => (
                                <div>
                                    <Tooltip
                                        openDelay={600}
                                        position="bottom"
                                        anchorElement="target"
                                        tooltipClassName="tooltipGeneralStyle"
                                    >
                                        <div>
                                            <img
                                                title={item.name}
                                                key={index}
                                                src={
                                                    item.avatarUrl && item.avatarUrl !== ""
                                                        ? item.avatarUrl
                                                        : newProfileIcon
                                                }
                                                className="validateFreelanceView-avatar"
                                                alt={item.name}
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            ))
                            }
                        </div>
                    </Grid>
                    <ChatBoxGLPure
                        user={usersChat}
                        conversation={conversation}
                        widthChat={1200}
                        heightChat={300}
                        placeholderChat={t("chatBoxGLPure.placeholder")}
                        handleInputChange={handleInputChangeChat}
                        createMessage={createMessage}
                        onMarkAsRead={markChatAsRead}
                    />
                </div>
            </PanelBarGLPure>
        </div>
    )
}

export { ValidateFreelanceChatView as default }